import {
  EventStore,
  EventModel,
  AssignmentStore,
  ResourceStore,
  ResourceModel,
  TimeRangeStore,
} from "@bryntum/schedulerpro";
import moment from "moment";

// == Model定義 ===
class CrewEventModel extends EventModel {
  static get fields() {
    return [
      { name: "name", readOnly: true, persist: false },
      { name: "startDate", dataSource: "start_date" },
      { name: "endDate", dataSource: "end_date" },
      // カスタムフィールド
      // 計画ステータス (予定/計画中)
      { name: "scheduling_status" },
      // イベント種類（乗船/下船/休暇希望）
      { name: "event_type" },
      // アラート情報
      { name: "alerts", defaultValue: [], persist: false, readOnly: true },
      // 乗船期間ID
      { name: "enterprise_manning_vessel_crew_id", defaultValue: null },
      // 下船中様態・休暇希望の備考
      { name: "remarks", persist: true, defaultValue: "" },
      // 下船中様態の種類
      {
        name: "enterprise_manning_status_id",
        persist: true,
        defaultValue: null,
      },
      // 船舶ID
      {
        name: "enterprise_manning_vessel_id",
        persist: true,
        defaultValue: null,
      },
      // 役職ポジションID
      {
        name: "enterprise_manning_vessel_role_position_id",
        persist: true,
        defaultValue: null,
      },
      // 役職ポジションID
      {
        name: "enterprise_crew_role_id",
        persist: true,
        defaultValue: null,
      },
      // 休暇希望の優先度
      {
        name: "priority",
        persist: true,
        defaultValue: null,
      },
      { name: "phantom_group_key", persist: true, defaultValue: null },
      // 楽観ロック用のバージョン番号
      { name: "version", persist: true, defaultValue: null },
      // 内部用削除フラグ
      { name: "innerDelete", persist: false, defaultValue: false },
      // 内部用用リプレースフラグ レコードをコピー&削除するフラグ
      { name: "innerReplace", persist: false, defaultValue: false },
      // 不要なデータは送らない
      // durationの単位は分にする。
      { name: "duration", persist: false },
      { name: "durationUnit", persist: false, defaultValue: "minute" },
      { name: "cls", persist: false },
      { name: "calendar", persist: false },
      { name: "direction", persist: false },
      { name: "manuallyScheduled", persist: false, defaultValue: true },
      { name: "unscheduled", persist: false },
      { name: "ignoreResourceCalendar", persist: false },
      { name: "percentDone", persist: false },
      { name: "effort", persist: false },
      { name: "effortUnit", persist: false },
      { name: "segments", persist: false },
      { name: "effortDriven", persist: false },
      { name: "schedulingMode", persist: false },
      { name: "constraintType", persist: false, defaultValue: null },
      { name: "constraintDate", persist: false, defaultValue: null },
      { name: "inactive", persist: false },
      { name: "delayFromParent", persist: false },
      { name: "exceptionDates", persist: false },
      { name: "allDay", persist: false },
      { name: "eventColor", persist: false },
      { name: "showInTimeline", persist: false },
      { name: "preamble", persist: false },
      { name: "postamble", persist: false },
    ];
  }
}

class Resouce extends ResourceModel {
  static fields = [
    { name: "name", readOnly: true },
    { name: "appointed_role_name", readOnly: true },
    { name: "employment_status", readOnly: true },
    { name: "retirement_date", readOnly: true },
    { name: "summaries", persist: false, defaultValue: [] },
  ];

  get isRetired() {
    const retirementDateStr = this.retirement_date;
    if (!retirementDateStr) {
      return false;
    }

    const retirementDate = moment(retirementDateStr).startOf("day");
    const today = moment().startOf("day");

    return retirementDate.isValid() && retirementDate.isBefore(today);
  }

  get readOnly() {
    return this.isParent;
  }

  get rowHeight() {
    if (this.isLeaf) {
      return super.rowHeight;
    }
    return 45;
  }
}

// == Store定義 ===

const CrewEventStore = new EventStore({
  sorters: [{ field: "startDate", ascending: true }],
  modelClass: CrewEventModel,
  onLoad(event) {
    const store = event.source;

    store.forEach(record => {
      // 全レコードはドラッグ禁止
      record.set("draggable", false);
    });
  },
});

const CrewAssignmentStore = new AssignmentStore({
  fields: [
    { name: "eventId", dataSource: "event_id" },
    { name: "resourceId", dataSource: "resource_id" },
    { name: "units", persist: false, defaultValue: 100 },
    { name: "version", persist: true },
  ],
});

/** 在籍を先・退職を後、退職者内は退職日が新しい順、在籍者は元順を維持 */
function crewResourceSorter(a, b) {
  if (!a.isLeaf && !b.isLeaf) return 0;
  if (!a.isLeaf) return -1;
  if (!b.isLeaf) return 1;
  const aRetired = a.isRetired;
  const bRetired = b.isRetired;
  if (aRetired !== bRetired) return aRetired ? 1 : -1;
  if (!aRetired && !bRetired) return 0;
  if (aRetired && bRetired) {
    const aDate = moment(a.retirement_date);
    const bDate = moment(b.retirement_date);
    if (aDate.isAfter(bDate)) return -1;
    if (aDate.isBefore(bDate)) return 1;
  }
  const aRole = (a.appointed_role_name || "").toString();
  const bRole = (b.appointed_role_name || "").toString();
  if (aRole !== bRole) return aRole < bRole ? -1 : 1;
  const aName = (a.name || "").toString();
  const bName = (b.name || "").toString();
  return aName < bName ? -1 : aName > bName ? 1 : 0;
}

const CrewResourceStore = new ResourceStore({
  tree: true,
  modelClass: Resouce,
  sorters: [{ fn: crewResourceSorter }],
});

const CrewTimeRangeStore = new TimeRangeStore({});

export {
  CrewEventStore,
  CrewEventModel,
  CrewAssignmentStore,
  CrewResourceStore,
  CrewTimeRangeStore,
  Resouce,
  crewResourceSorter,
};
